<template>
  <main class="help-center-host" aria-hidden="true" />
</template>

<script>
export default {
  name: 'HelpCenterHost'
}
</script>

<style scoped>
.help-center-host {
  min-height: 100vh;
  background: var(--up-canvas);
}
</style>
